import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ProviderInNetwork: {
        id: 'Search.Results.ProviderInNetwork',
        defaultMessage: 'In-network providers',
    },

    ProviderOutOfNetwork: {
        id: 'Search.Results.ProviderOutOfNetwork',
        defaultMessage: 'Out-of-network providers',
    },

    ProviderOther: {
        id: 'Search.Results.ProviderOther',
        defaultMessage: 'Other providers',
    },
});

export const PROVIDER_RESULT_TYPES = {
    IN_NETWORK: 'IN_NETWORK',
    NON_INSURANCE: 'NON_INSURANCE',
    OTHER: 'OTHER',
    OUT_OF_NETWORK: 'OUT_OF_NETWORK',
};

export const TRACKING_CLICK_LOCATIONS = {
    Card: 'DoctorCard',
    Location: 'DoctorAddress',
    Name: 'DoctorName',
    NextAvailability: 'TimesGridJumpToDate',
    Photo: 'DoctorPhoto',
    Rating: 'DoctorRating',
    Timeslot: 'TimesGridSlot',
};

export const INFO_TEXT_FONT_SIZE = 14;
export const INFO_TEXT_LINE_HEIGHT = 20;
export const STARS_BASE_SIZE = 12;
export const STARS_MEDIUM_SIZE = 16;
export const PHOTO_SIZE_XXSMALL = 72;
export const PHOTO_SIZE_MEDIUM = 88;
export const PHOTO_SIZE_LARGE = 110;
